import * as THREE from "three";

import * as ZapparThree from "@zappar/zappar-threejs";
import { Permission } from "@zappar/zappar";
import EyewareAssets from "./EyewareAssets";
import EyewareEffects from "./EyewareEffects";

import Renderer from "./Renderer";

export default class Experience {
  private renderer: Renderer;
  private scene = new THREE.Scene();
  private camera: THREE.PerspectiveCamera;
  private zapparCamera: ZapparThree.Camera;

  private eyeConditionType: string;
  private severityLevel: number;
  private eyewareEffects: EyewareEffects;

  constructor() {
    this.eyeConditionType = "none";
    this.severityLevel = 1;

    this.camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000,
    );

    this.renderer = new Renderer();

    // The Zappar library needs the WebGL context to process camera images
    // Use this function to set your context
    ZapparThree.glContextSet(this.renderer.getContext());

    // Create a camera and set the scene background to the camera's backgroundTexture
    this.zapparCamera = new ZapparThree.Camera();
    this.zapparCamera.backgroundTexture.encoding = THREE.sRGBEncoding;

    this.eyewareEffects = new EyewareEffects({
      assets: EyewareAssets,
    });

    this.eventListeners();
  }

  public async getPermissions() {
    const granted = await ZapparThree.permissionRequest(Permission.CAMERA);
    if (granted) {
      this.zapparCamera.start();
      setTimeout(() => {
        this.zapparCamera.start();
        setTimeout(() => {
          this.zapparCamera.start();
        }, 500);
      }, 500);
    } else {
      // User denied the permissions so show Zappar's built-in 'permission denied' UI
      ZapparThree.permissionDeniedUI();
    }
    return granted;
  }

  private animate = () => {
    // The Zappar camera should have updateFrame called every frame
    this.zapparCamera.updateFrame(this.renderer);
    // effects passes
    this.eyewareEffects.render({
      renderer: this.renderer,
      camera: this.zapparCamera,
      condition: this.eyeConditionType,
      severity: this.severityLevel,
      mode: "mono",
    });

    this.camera.updateWorldMatrix(true, true);
    this.renderer.mainRender(
      this.scene,
      this.camera,
      this.eyewareEffects.texture,
    );

    // Ask the browser to call this function again next frame
    requestAnimationFrame(this.animate);
  };

  public startScene() {
    const homepageElement = document.querySelector("#homepage") as HTMLElement;
    if (!homepageElement) return;
    homepageElement.classList.add("active");
    // Ask the browser to call this function again next frame
    requestAnimationFrame(this.animate);
  }

  private eventListeners() {
    document.addEventListener("rnib:condition", (e: CustomEventInit) => {
      let condition = e.detail.condition;
      if (condition.startsWith("armd-")) {
        condition = "armd";
      }
      this.eyeConditionType = condition;
      this.severityLevel = e.detail.severity;
    });
  }
}
